import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { profileActions } from 'features/profile';

const useProfile = () => {
  const dispatch = useDispatch();
  const getProfile = useCallback(() => dispatch(profileActions.getProfile()), [dispatch]);
  const updateProfile = useCallback((manager) => dispatch(profileActions.updateProfile(manager)), [dispatch]);

  return { getProfile, updateProfile };
};

export default useProfile;